// Test IDs for admin dashboard and authenticated flows.

export const ADMIN_DASH = {
  page: 'admin-dashboard',
  navInquiries: 'admin-nav-inquiries',
  navProducts: 'admin-nav-products',
  logout: 'admin-logout-button',
  userBadge: 'admin-user-badge',

  // Inquiries
  inquiriesPanel: 'admin-inquiries-panel',
  inquiriesFilter: (slug) => `admin-inquiries-filter-${slug}`,
  inquiriesSourceFilter: (slug) => `admin-inquiries-source-${slug}`,
  inquiryRow: (id) => `admin-inquiry-row-${id}`,
  inquiryStatusSelect: (id) => `admin-inquiry-status-${id}`,
  inquiryDelete: (id) => `admin-inquiry-delete-${id}`,
  inquiryExport: 'admin-inquiry-export-csv',

  // Products
  productsPanel: 'admin-products-panel',
  productsFilter: (slug) => `admin-products-filter-${slug}`,
  productsNew: 'admin-products-new',
  productRow: (id) => `admin-product-row-${id}`,
  productEdit: (id) => `admin-product-edit-${id}`,
  productDelete: (id) => `admin-product-delete-${id}`,

  // Product form modal
  productForm: 'admin-product-form',
  productFormCategory: 'admin-product-form-category',
  productFormName: 'admin-product-form-name',
  productFormCut: 'admin-product-form-cut',
  productFormDescription: 'admin-product-form-description',
  productFormGrade: 'admin-product-form-grade',
  productFormOrigin: 'admin-product-form-origin',
  productFormImageUrl: 'admin-product-form-image-url',
  productFormImageUpload: 'admin-product-form-image-upload',
  productFormFeatured: 'admin-product-form-featured',
  productFormSubmit: 'admin-product-form-submit',
  productFormCancel: 'admin-product-form-cancel',
};

export const AUTH = {
  loginPage: 'auth-login-page',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  submitButton: 'auth-submit-button',
  googleButton: 'auth-google-button',
  errorMessage: 'auth-error-message',
};
